import React from 'react';
import { browserWarningMessage } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';

import './BrowserWarning.css';

const BrowserWarning = () => {
  const browsers = ['Chrome', 'Firefox', 'Edge'];
  const browserIcons = [IconLoader.icon_browser_chrome, IconLoader.icon_browser_firefox, IconLoader.icon_browser_edge];

  return (
    <div className="BrowserWarning_MainBox">
      <div className="BrowserWarning_Title">{browserWarningMessage.title}</div>
      <div className="BrowserWarning_Body">
        <div className="BrowserWarning_BodyText">{browserWarningMessage.body1}</div>
        <div className="BrowserWarning_BodyText">{browserWarningMessage.body2}</div>
      </div>
      <div className="BrowserWarning_BrowserList">
        {browsers.map((browser, index) => (
          <div className={`SingleBrowser Browser_${browser}`} key={browser}>
            <div className="BrowserIcon">
              <img src={browserIcons[index]} alt="" />
            </div>
            <div className="BrowserText">{browser}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrowserWarning;
